/*
 * Utility for assembling className strings in components.
 */
var LegacyClassBuilder = /** @class */ (function () {
    function LegacyClassBuilder(component) {
        this.classNameSet = {};
        this.component = component;
    }
    LegacyClassBuilder.prototype.addClass = function (className, condition) {
        var conditionMet;
        /*
         * I want 'undefined' to work as a falsy condition, but I'd like to avoid defining separate
         * methods for adding classes conditionally.
         */
        if (arguments.length < 2) {
            conditionMet = true;
        }
        else {
            conditionMet = !!condition;
        }
        if (className && conditionMet) {
            this.classNameSet[className] = true;
        }
        return this;
    };
    LegacyClassBuilder.prototype.addPropertyValueClass = function (propertyName, condition) {
        var component = this.component;
        var propertyValue = component[propertyName];
        if (propertyValue) {
            var classSuffix = propertyName + "-" + propertyValue;
            if (arguments.length < 2) {
                this.addComponentClass(classSuffix);
            }
            else {
                this.addComponentClass(classSuffix, condition);
            }
        }
        return this;
    };
    LegacyClassBuilder.prototype.toClassName = function () {
        var classNames = Object.keys(this.classNameSet);
        classNames.sort(); // ensure consistent ordering across browsers, mainly for unit tests
        return classNames.join(' ');
    };
    LegacyClassBuilder.prototype.addComponentClass = function (suffix, condition) {
        var className = this.component.__componentName + "-" + suffix;
        if (arguments.length < 2) {
            this.addClass(className);
        }
        else {
            this.addClass(className, condition);
        }
        return this;
    };
    return LegacyClassBuilder;
}());
export default LegacyClassBuilder;
//# sourceMappingURL=legacy.js.map